import { render, staticRenderFns } from "./NavigationBarItem.vue?vue&type=template&id=5ac3b14e&functional=true"
var script = {}
import style0 from "./NavigationBarItem.vue?vue&type=style&index=0&id=5ac3b14e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports